import { FormEvent } from "react";

export const getFormValue = (
  name: string,
  e: FormEvent<HTMLFormElement>
): string => {
  const target = e.target as any;
  return target[name].value;
};
